import { Fold } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { _Cards } from "./optics";
const ContentGroupView = React.lazy(() => import("../../components/molecules/content-group"));
const getProps = (data) => {
    const titleM = Fold.view(Optics._ColAttributes2Title, data);
    const cardsData = Fold.toArray(_Cards, data);
    return {
        titleM,
        cardsData,
    };
};
const ContentGroup = ({ titleM, cardsData }) => {
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ContentGroupView, { titleM: titleM, cardsData: cardsData })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, ContentGroup);

